module.exports = __webpack_public_path__ + "img/c5201809-5.de6015ff.jpg";